import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { ThemeService } from './ncs/services/theme.service';

declare var WOW: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'ClientApp';
 
  private routerSubscription?: Subscription;

  constructor(private ngxService: NgxUiLoaderService, private router: Router, private themeService: ThemeService) {
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      if (typeof WOW !== 'undefined') {
        new WOW().init();
      }
    });
  }

  ngOnInit() {
    this.ngxService.startLoader('loader-01');
    setTimeout(() => {
      this.ngxService.stopLoader('loader-01');
    }, 5000);

    if (typeof WOW !== 'undefined') {
      new WOW().init();
    }
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
